import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const riseRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Rise.ai" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { Component: Page };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { RiseSetupInstructions } = await import("./integration-setup");
          return { Component: RiseSetupInstructions };
        },
      },
    ],
  },
];
